import { render, staticRenderFns } from "./WSAlert.vue?vue&type=template&id=0669dc6c&scoped=true&"
import script from "./WSAlert.vue?vue&type=script&lang=ts&"
export * from "./WSAlert.vue?vue&type=script&lang=ts&"
import style0 from "./WSAlert.vue?vue&type=style&index=0&id=0669dc6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0669dc6c",
  null
  
)

export default component.exports